module.exports = __webpack_public_path__ + "images/goal-digger-eff8614567879ae2ccd0440cdaaa1e2a.png";